export enum Status {
  NotAsked = 'NOT_ASKED',
  Agreed = 'AGREED',
  Declined = 'DECLINED',
  ExpiredSoon = 'EXPIRED_SOON',
  Expired = 'EXPIRED',
}

export enum Action {
  NotNeeded = 'NOT_NEEDED',
  Upcoming = 'UPCOMING',
  Needed = 'NEEDED',
}

export const consentGiven = [
  'FACE_TO_FACE',
  'EMAIL',
  'LEGACY_SYSTEM',
  'TELEPHONE',
  'SELF_SERVICE',
] as const

export type ConsentGiven = (typeof consentGiven)[number]

export const ConsentMethod = {
  FaceToFace: 'FACE_TO_FACE',
  Email: 'EMAIL',
  LegacySystem: 'LEGACY_SYSTEM',
  Telephone: 'TELEPHONE',
  SelfService: 'SELF_SERVICE',
} as const satisfies Record<string, ConsentGiven>

export type ConsentMethod = (typeof ConsentMethod)[keyof typeof ConsentMethod]

/**
 * Help text display style names used in frontend components.
 * Backend converts integer values to these string names before sending.
 * @see pcloud/provet/organization/client_config_builders.py
 */
export const HelpTextStyleName = {
  ShowOnHover: 'SHOW_ON_HOVER',
  ShowFullText: 'SHOW_FULL_TEXT',
} as const

export type HelpTextStyleNameValue =
  (typeof HelpTextStyleName)[keyof typeof HelpTextStyleName]

/**
 * Communication preference row channel values
 */
export interface CommunicationPreferenceChannels {
  sms: boolean
  email: boolean
  phone: boolean
  post: boolean
}

/**
 * Communication preference field name pattern
 */
export const COMMUNICATION_PREFERENCE_FIELD_PREFIX = 'communication_preference_'
